module.exports = __webpack_public_path__ + "static/media/blog-img-03.011780a6.jpg";